import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/BotonPSE.png'


const _withScopeId = n => (_pushScopeId("data-v-3f307dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-base text-center font-bold text-primary mb-2" }, [
    /*#__PURE__*/_createTextVNode(" ¡Felicitaciones! "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Tenemos un trato ")
  ])
], -1))
const _hoisted_2 = { class: "text-gris120 text-sm mb-3" }
const _hoisted_3 = { class: "text-gris120 text-sm mb-3" }
const _hoisted_4 = { class: "text-gris120 text-sm mb-3" }
const _hoisted_5 = { class: "flex flex-col pt-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "pse",
  class: "btn-pse"
}, null, -1))
const _hoisted_7 = {
  href: "",
  ref: "iPhoneLink",
  rel: "noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPaymentChannels = _resolveComponent("ModalPaymentChannels")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock(_component_NewModal, {
          key: 0,
          "custom-class": 'bg-white rounded-lg h-auto p-8 w-auto max-w-sm overflow-x-hidden',
          onCloseModal: _ctx.close
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode(" Confirmamos la aprobación del acuerdo de pago número "),
              _createElementVNode("strong", null, "# " + _toDisplayString(_ctx.negotiationDone?.negotiation_id), 1),
              _createTextVNode(". Hemos enviado a su correo electrónico toda la información del acuerdo. ")
            ]),
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(" El valor total del trato es de "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.currency(
          _ctx.negotiationDone?.payment_information?.full_total_payment
        )), 1),
              _createTextVNode(". ")
            ]),
            _createElementVNode("p", _hoisted_4, [
              _createTextVNode(" El primer pago a realizar es de "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$filters.currency(_ctx.negotiationDone?.payment_information?.value)), 1),
              _createTextVNode(". ")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.physicalPayment && _ctx.physicalPayment(...args)), ["prevent"])),
                class: "w-full px-4 py-2 mt-3 md:mt-0 text-sm text-white rounded-lg bg-secondary border md:w-auto md:text-sm h-10 mb-3"
              }, " Pago en efectivo "),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onlinePayment && _ctx.onlinePayment(...args)), ["prevent"])),
                class: "w-full px-4 py-2 text-sm mt-3 text-white rounded-lg bg-success md:mt-0 md:text-sm order-first md:order-none btn-pse-container h-10"
              }, [
                _hoisted_6,
                _createTextVNode(" Realizar pago online ")
              ])
            ]),
            _createVNode(_component_ModalPaymentChannels, {
              "is-visible": _ctx.showModalPaymentChannels,
              paymentChannels: _ctx.getReferenceAndAgreement,
              onClose: _ctx.closeModalPaymentChannels
            }, null, 8, ["is-visible", "paymentChannels", "onClose"])
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true),
    _createElementVNode("a", _hoisted_7, null, 512)
  ], 64))
}